import { gql } from '@apollo/client';

export const GET_UPLOAD_URL = gql`
    mutation GetUploadUrl($input: GetUploadUrlInput!) {
        getManualImportUploadUrl(input: $input) {
            url
            key
        }
    }
`;
